export const englishCrmMessages = {
  resources: {
    companies: {
      name: "Customer |||| Customers",
      forcedCaseName: "Customer",
      fields: {
        name: "Customer name",
        website: "Website",
        linkedin_url: "LinkedIn URL",
        phone_number: "Phone number",
        created_at: "Created at",
        nb_contacts: "Number of contacts",
        revenue: "Revenue",
        sector: "Segment",
        segments: "Segments",
        size: "Size",
        tax_identifier: "Tax Identifier",
        address: "Address",
        city: "City",
        zipcode: "Zip code",
        state_abbr: "State",
        country: "Country",
        description: "Description",
        context_links: "Context links",
        sales_id: "Account manager",
      },
      empty: {
        description: "It seems your customer list is empty.",
        title: "No customers found",
        bc_sync_description:
          "Customers are synced from Business Central. Check Settings → BC Sync or wait for the nightly sync.",
      },
      field_categories: {
        contact: "Contact",
        additional_info: "Additional information",
        address: "Address",
        context: "Context",
      },
      action: {
        create: "Create Customer",
        edit: "Edit customer",
        new: "New Customer",
        show: "Show customer",
      },
      added_on: "Added on %{date}",
      followed_by: "Salesperson: %{name}",
      followed_by_you: "Salesperson: you",
      no_contacts: "No contact",
      nb_contacts: "%{smart_count} contact |||| %{smart_count} contacts",
      nb_deals: "%{smart_count} deal |||| %{smart_count} deals",
      sizes: {
        one_employee: "1 employee",
        two_to_nine_employees: "2-9 employees",
        ten_to_forty_nine_employees: "10-49 employees",
        fifty_to_two_hundred_forty_nine_employees: "50-249 employees",
        two_hundred_fifty_or_more_employees: "250 or more employees",
      },
      autocomplete: {
        create_error: "An error occurred while creating the customer",
        create_item: "Create %{item}",
        create_label: "Start typing to create a new customer",
      },
      filters: {
        only_mine: "Only customers I manage",
      },
    },
    campaigns: {
      name: "Campaign |||| Campaigns",
      fields: {
        name: "Name",
        description: "Description",
        status: "Status",
        product_name: "Product",
        kind: "Task type",
        title: "Title",
        instructions: "Instructions",
        assignee: "Assignee",
        targets: "Targets",
      },
      tabs: {
        overview: "Overview",
        definitions: "Task definitions",
        my_tasks: "My tasks",
      },
      task_definitions: {
        add: "Add task definition",
        edit: "Edit task definition",
        empty: "No task definitions yet.",
        targets: "targets",
        generated: "Generated",
      },
      targets: {
        add: "Add target",
        required: "Add at least one target",
        empty: "No campaign targets configured yet.",
        campaign_required:
          "Add campaign targets before using inherited targeting",
        mode: "Target mode",
        inherit: "Inherit targets from campaign",
        custom: "Use custom targets for this definition",
        inherited_badge: "Inherited from campaign",
        select_segment: "Select segment…",
        select_company: "Select company…",
        select_contact: "Select contact…",
        select_tag: "Select tag…",
        types: {
          segment: "BC Segment",
          company: "Company",
          contact: "Contact",
          tag: "Tag",
        },
      },
      assignee: {
        required: "Select an assignee",
      },
      generate: {
        action: "Generate tasks",
        reconcile: "Reconcile tasks",
        confirm: "Generate",
        fallback: "Fallback salesperson",
        fallback_help:
          "Select a fallback salesperson for targets without an assigned salesperson.",
        success: "Tasks generated",
        created: "Created",
        skipped: "Skipped",
        deleted: "Removed",
        missing: "Skipped (no salesperson)",
      },
      complete_note: {
        title: "Add note to task",
        placeholder: "Write a note about this visit or call…",
        save: "Save note",
        skip: "Complete without note",
        success: "Task completed",
        saved_to_contact: "Note will be saved to contact: %{name}",
        saved_to_company: "Note will be saved to company: %{name}",
      },
      status: {
        draft: "Draft",
        active: "Active",
        completed: "Completed",
        overdue: "Overdue",
        open: "Open",
        snoozed: "Snoozed",
      },
      progress: {
        label: "Progress",
        overdue_count: "%{count} overdue",
      },
      open_tasks: {
        title: "Tasks",
        show_completed: "Show completed",
        all_completed: "All tasks completed.",
        campaign_task: "Campaign task",
        company_fallback: "Company #%{id}",
        contact_fallback: "Contact #%{id}",
      },
      kinds: {
        visit_demo: "Visit & demo",
        phone_call: "Phone call",
        send_samples: "Send samples",
        send_info: "Send product info",
        meeting: "Meeting",
        follow_up: "Follow-up",
        newsletter: "Send newsletter",
        personal_task: "Personal task",
      },
      metadata: {
        product_to_demo: "Product to demo",
        talk_points: "Talk points",
        sample_description: "Sample description",
        materials: "Materials to send",
        meeting_format: "Meeting format (in_person or online)",
        newsletter_subject: "Newsletter subject",
        notes: "Notes",
      },
    },
    contacts: {
      name: "Contact |||| Contacts",
      forcedCaseName: "Contact",
      field_categories: {
        background_info: "Background info",
        identity: "Identity",
        misc: "Misc",
        personal_info: "Personal info",
        position: "Position",
      },
      fields: {
        first_name: "First name",
        last_name: "Last name",
        last_seen: "Last seen",
        title: "Title",
        company_id: "Company",
        email_jsonb: "Email addresses",
        email: "Email",
        phone_jsonb: "Phone numbers",
        phone_number: "Phone number",
        linkedin_url: "LinkedIn URL",
        background: "Background info (bio, how you met, etc)",
        has_newsletter: "Has newsletter",
        sales_id: "Account manager",
      },
      action: {
        add: "Add contact",
        add_first: "Add your first contact",
        browse_synced: "Browse synced contacts",
        create: "Create contact",
        edit: "Edit contact",
        export_vcard: "Export to vCard",
        new: "New Contact",
        show: "Show contact",
      },
      background: {
        last_activity_on: "Last activity on %{date}",
        added_on: "Added on %{date}",
        followed_by: "Salesperson: %{name}",
        followed_by_you: "Salesperson: you",
        status_none: "None",
      },
      position_at: "%{title} at",
      position_at_company: "%{title} at %{company}",
      part_of_company: "Part of %{name}",
      open_company: "Open company",
      empty: {
        description: "It seems your contact list is empty.",
        title: "No contacts found",
        bc_sync_description:
          "Contacts are synced from Business Central. Check Settings → BC Sync or wait for the nightly sync.",
      },
      import: {
        title: "Import contacts",
        button: "Import CSV",
        complete:
          "Contacts import complete. Imported %{importCount} contacts, with %{errorCount} errors",
        progress:
          "Imported %{importCount} / %{rowCount} contacts, with %{errorCount} errors.",
        error:
          "Failed to import this file, please make sure your provided a valid CSV file.",
        imported: "Imported",
        remaining_time: "Estimated remaining time:",
        running: "The import is running, please do not close this tab.",
        sample_download: "Download CSV sample",
        sample_hint: "Here is a sample CSV file you can use as a template",
        stop: "Stop import",
        csv_file: "CSV File",
        contacts_label: "contact |||| contacts",
      },
      inputs: {
        genders: {
          male: "He/Him",
          female: "She/Her",
          nonbinary: "They/Them",
        },
        personal_info_types: {
          work: "Work",
          home: "Home",
          other: "Other",
        },
      },
      list: {
        error_loading: "Error loading contacts",
      },
      bulk_tag: {
        action: "Tag",
        back: "Back to tags",
        create_description:
          "Create a new tag and apply it to the selected contacts.",
        description:
          "Choose an existing tag or create a new one for the selected contacts.",
        empty: "No tags yet. Create one to tag the selected contacts.",
        error: "Failed to add tag to contacts",
        noop: "Selected contacts already have this tag",
        success:
          "Tag added to %{smart_count} contact |||| Tag added to %{smart_count} contacts",
        title: "Add tag to contacts",
      },
      merge: {
        action: "Merge with another contact",
        confirm: "Merge Contacts",
        current_contact: "Current Contact (will be deleted)",
        description: "Merge this contact with another one.",
        error: "Failed to merge contacts",
        merging: "Merging...",
        no_additional_data: "No additional data to merge",
        select_target: "Please select a contact to merge with",
        success: "Contacts merged successfully",
        target_contact: "Target Contact (will be kept)",
        title: "Merge Contact",
        warning_description:
          "All data will be transferred to the second contact. This action cannot be undone.",
        warning_title: "Warning: Destructive Operation",
        what_will_be_merged: "What will be merged:",
      },
      filters: {
        before_last_month: "Before last month",
        before_this_month: "Before this month",
        before_this_week: "Before this week",
        managed_by_me: "Managed by me",
        search: "Search name, company...",
        this_week: "This week",
        today: "Today",
        tags: "Tags",
        tasks: "Tasks",
      },
      hot: {
        empty_change_status:
          'Change the status of a contact by adding a note to that contact and clicking on "show options".',
        empty_hint: 'Contacts with a "hot" status will appear here.',
        title: "Hot Contacts",
      },
    },
    deals: {
      name: "Deal |||| Deals",
      fields: {
        name: "Name",
        description: "Description",
        company_id: "Company",
        contact_ids: "Contacts",
        category: "Category",
        amount: "Budget",
        expected_closing_date: "Expected closing date",
        stage: "Stage",
      },
      action: {
        back_to_deal: "Back to deal",
        create: "Create deal",
        new: "New Deal",
      },
      field_categories: {
        misc: "Misc",
      },
      archived: {
        action: "Archive",
        error: "Error: deal not archived",
        list_title: "Archived Deals",
        success: "Deal archived",
        title: "Archived Deal",
        view: "View archived deals",
      },
      inputs: {
        linked_to: "Linked to",
      },
      unarchived: {
        action: "Send back to the board",
        error: "Error: deal not unarchived",
        success: "Deal unarchived",
      },
      updated: "Deal updated",
      empty: {
        before_create: "before creating a deal.",
        description: "It seems your deal list is empty.",
        title: "No deals found",
      },
      invalid_date: "Invalid date",
    },
    notes: {
      name: "Note |||| Notes",
      forcedCaseName: "Note",
      fields: {
        status: "Status",
        date: "Date",
        attachments: "Attachments",
        contact_id: "Contact",
        deal_id: "Deal",
      },
      action: {
        add: "Add note",
        add_first: "Add your first note",
        delete: "Delete note",
        edit: "Edit note",
        update: "Update note",
        add_this: "Add this note",
      },
      sheet: {
        create: "Create note",
        create_for: "Create note for %{name}",
        edit: "Edit note",
        edit_for: "Edit note for %{name}",
      },
      deleted: "Note deleted",
      empty: "No notes yet",
      author_added: "%{name} added a note",
      you_added: "You added a note",
      me: "Me",
      list: {
        error_loading: "Error loading notes",
      },
      note_for_contact: "Note for %{name}",
      stepper: {
        hint: "Go to a contact page and add a note",
      },
      added: "Note added",
      inputs: {
        add_note: "Add a note",
        options_hint: "(attach files, or change details)",
        show_options: "Show options",
      },
      actions: {
        attach_document: "Attach document",
      },
      validation: {
        note_or_attachment_required: "A note or an attachment is required",
      },
    },
    sales: {
      name: "User |||| Users",
      fields: {
        first_name: "First name",
        last_name: "Last name",
        email: "Email",
        administrator: "Admin",
        disabled: "Disabled",
        role: "Role",
      },
      roles: {
        admin: "Administrator",
        manager: "Manager",
        user: "User",
      },
      create: {
        error: "An error occurred while creating the user.",
        success:
          "User created. They will soon receive an email to set their password.",
        title: "Create a new user",
      },
      edit: {
        error: "An error occurred. Please try again.",
        record_not_found: "Record not found",
        success: "User updated successfully",
        title: "Edit %{name}",
      },
      action: {
        new: "New user",
      },
    },
    tasks: {
      name: "Task |||| Tasks",
      forcedCaseName: "Task",
      fields: {
        text: "Description",
        due_date: "Due date",
        type: "Type",
        contact_id: "Contact",
        sales_id: "Assigned to",
        due_short: "due",
      },
      action: {
        add: "Add task",
        create: "Create task",
        edit: "Edit task",
      },
      actions: {
        postpone_next_week: "Postpone to next week",
        postpone_tomorrow: "Postpone to tomorrow",
        title: "task actions",
      },
      added: "Task added",
      deleted: "Task deleted successfully",
      dialog: {
        create: "Create task",
        create_for: "Create task for %{name}",
      },
      sheet: {
        edit: "Edit task",
        edit_for: "Edit task for %{name}",
      },
      empty: "No tasks yet",
      empty_list_hint: "Tasks added to your contacts will appear here.",
      filters: {
        later: "Later",
        overdue: "Overdue",
        this_week: "This week",
        today: "Today",
        tomorrow: "Tomorrow",
        with_pending: "With pending tasks",
        campaign_tasks: "Campaign tasks only",
      },
      regarding_contact: "(Re: %{name})",
      regarding_company: "(Re: %{name})",
      assigned_to: "Assigned: %{name}",
      updated: "Task updated",
      recurrence: {
        badge: "Recurring",
        enabled: "Recurring task",
        every_day: "Every day",
        every_week: "Every week",
        every_month: "Every month",
        every_year: "Every year",
        custom: "Custom",
        every_count: "Interval",
        every_count_help: "Use 1 for every interval, or higher for every N intervals.",
        every_unit: "Unit",
        days: "Days",
        weeks: "Weeks",
        months: "Months",
        years: "Years",
        has_end_date: "Set end date",
        end_date: "End date",
      },
    },
    tags: {
      name: "Tag |||| Tags",
      action: {
        add: "Add tag",
        create: "Create new tag",
      },
      dialog: {
        color: "Color",
        create_title: "Create a new tag",
        edit_title: "Edit tag",
        name_label: "Tag name",
        name_placeholder: "Enter tag name",
      },
    },
  },
  crm: {
    action: {
      reset_password: "Reset Password",
    },
    auth: {
      first_name: "First name",
      last_name: "Last name",
      confirm_password: "Confirm password",
      confirmation_required:
        "Please follow the link we just sent you by email to confirm your account.",
      recovery_email_sent:
        "If you're a registered user, you should receive a password recovery email shortly.",
      sign_in_failed: "Failed to log in.",
      sign_in_google_workspace: "Sign in with Google Workplace",
      signup: {
        create_account: "Create account",
        create_first_user:
          "Create the first user account to complete the setup.",
        creating: "Creating...",
        initial_user_created: "Initial user successfully created",
      },
      welcome_title: "Welcome to Atomic CRM",
    },
    mfa: {
      setup: {
        title: "Set up two-factor authentication",
        subtitle:
          "Two-factor authentication is required before you can use Gobo CRM.",
        choose_totp: "Authenticator app (recommended)",
        choose_sms: "SMS text message",
        backup_hint:
          "Tip: Add a backup authenticator app in your profile so you are not locked out.",
      },
      verify: {
        title: "Verify your identity",
        subtitle: "Enter the code from your authenticator app or SMS.",
        submit: "Verify",
      },
      set_password: {
        title: "Verify before changing password",
        subtitle:
          "Enter your two-factor code to continue. This is required because MFA is enabled on your account.",
      },
      settings: {
        title: "Two-factor authentication",
        description:
          "Manage your MFA factors. We recommend keeping a backup authenticator app.",
        none: "No MFA factors enrolled.",
        remove: "Remove",
        add_factor: "Add backup factor",
      },
      totp: {
        friendly_name: "Authenticator app",
        description:
          "Use Microsoft Authenticator, Google Authenticator, or another TOTP app.",
        start: "Set up authenticator app",
        manual_secret: "Manual entry key:",
        scan_hint:
          "Scan the QR code, then enter the 6-digit code from your app.",
      },
      sms: {
        friendly_name: "SMS",
        description:
          "Receive one-time codes via SMS. Use international format, e.g. +4512345678.",
        phone: "Phone number",
        send_code: "Send code",
        code_sent: "Enter the code we sent to your phone.",
      },
      code: "Verification code",
      remember_device: "Remember this device for 30 days",
      verify_and_continue: "Verify and continue",
      back: "Back",
      setup_complete: "Two-factor authentication is now enabled.",
      enroll_error: "Could not start MFA setup. Please try again.",
      verify_error: "Invalid code. Please try again.",
      trusted_device_error:
        "MFA is enabled, but we could not remember this device.",
      no_factor: "No MFA factor found. Set up two-factor authentication first.",
      factor_removed: "MFA factor removed.",
      unenroll_error: "Could not remove MFA factor. Try again.",
      demo: {
        stub: "Demo mode: MFA is simulated. Click continue to proceed.",
        continue: "Continue",
      },
    },
    common: {
      activity: "Activity",
      added: "added",
      details: "Details",
      last_activity_with_date: "last activity %{date}",
      load_more: "Load more",
      misc: "Misc",
      past: "Past",
      read_more: "Read more",
      retry: "Retry",
      show_less: "Show less",
      copied: "Copied!",
      copy: "Copy",
      loading: "Loading...",
      me: "Me",
      task_count: "%{smart_count} task |||| %{smart_count} tasks",
    },
    activity: {
      added_company: "%{name} added company",
      you_added_company: "You added company",
      added_contact: "%{name} added",
      you_added_contact: "You added",
      added_note: "%{name} added a note about",
      you_added_note: "You added a note about",
      added_note_about_deal: "%{name} added a note about deal",
      you_added_note_about_deal: "You added a note about deal",
      added_company_note: "%{name} added a note about",
      you_added_company_note: "You added a note about",
      added_deal: "%{name} added deal",
      you_added_deal: "You added deal",
      at_company: "at",
      to: "to",
      load_more: "Load more activity",
    },
    dashboard: {
      deals_chart: "Upcoming Deal Revenue",
      deals_pipeline: "Deals Pipeline",
      latest_activity: "Latest Activity",
      latest_activity_error: "Error loading latest activity",
      latest_notes: "My Latest Notes",
      latest_notes_added_ago: "added %{timeAgo}",
      stepper: {
        install: "Install Atomic CRM",
        progress: "%{step}/3 done",
        whats_next: "What's next?",
      },
      upcoming_tasks: "Upcoming Tasks",
    },
    header: {
      import_data: "Import data",
    },
    recent_website_activity: {
      title: "Recent website activity",
      empty: "No recent website activity found",
      loading: "Loading...",
      demo_unavailable:
        "Recent website activity requires Leadboxer configuration and is not available in demo mode.",
      summary:
        "%{count} visits · %{visits} sessions · %{events} page views (latest)",
      match_reason: {
        domain: "Matched by domain",
        domain_alias: "Matched by domain alias",
        email_domain: "Matched by email domain",
        linkedin: "Matched by LinkedIn",
        name: "Matched by name",
      },
    },
    visitor_insights: {
      nav: "Visitor Insights",
      title: "Visitor Insights",
      description: "View identified organizations visiting your websites.",
      brand_title: "%{brand} Visitor Insights",
      brand_description: "Website visitor data for %{brand}.",
      demo_unavailable:
        "Visitor Insights requires Leadboxer configuration and is not available in demo mode.",
      loading: "Loading...",
      loading_sessions: "Loading sessions...",
      empty: "No visitors found for this period.",
      no_sessions: "No sessions found for this lead.",
      view_customer: "View customer",
      session_events: "Session Events",
      brands: {
        gobo_dk: "Gobo DK",
        gobo_se: "Gobo SE",
        gobo_fi: "Gobo FI",
        gobo_light: "Gobo Light Solution",
        ljusdesign: "Ljusdesign",
      },
      period: {
        last_24h: "Last 24 Hours",
        last_3d: "Last 3 Days",
        last_7d: "Last 7 Days",
        last_30d: "Last 30 Days",
      },
      columns: {
        summary: "Summary",
        last_activity: "Last Activity",
        industry: "Industry",
        employees: "Employees",
        visits: "Visits",
        events: "Events",
        last_channel: "Last Channel",
      },
      fields: {
        industry: "Industry",
        employees: "Employees",
        location: "Location",
        phone: "Phone",
        website: "Website",
        score: "Score",
        tags: "Tags",
      },
    },
    email_lists: {
      nav: "Email lists",
      title: "Email lists",
      description:
        "View and manage Encharge mailing list subscriptions across Gobo brands.",
      brand_title: "%{brand} contacts",
      brand_description: "Mailing list contacts for %{brand}.",
      demo_unavailable:
        "Email lists require Encharge configuration and are not available in demo mode.",
      loading: "Loading...",
      loading_more: "Loading more...",
      empty: "No contacts found.",
      search_placeholder: "Search contacts...",
      all_categories: "All categories",
      create_contact: "Create contact",
      create_title: "Create contact",
      edit_title: "Edit contact",
      saving: "Saving...",
      showing_count: "%{count} contacts in list",
      exists_prompt:
        "A contact with this email already exists. Update the existing contact instead?",
      update_existing: "Update existing",
      widget_title: "Email lists",
      widget_no_email: "Add an email address to see list subscriptions.",
      widget_empty: "No email list subscriptions found.",
      match_email: "Matched by email",
      match_company: "Matched by company",
      validation: {
        required_fields: "First name, last name, and email are required.",
        category_required: "Select at least one communication category.",
      },
      fields: {
        email: "Email",
        first_name: "First name",
        last_name: "Last name",
        company: "Company",
        phone: "Phone",
        postcode: "Postcode",
        contact_person: "Gobo contact person",
        categories: "Communication categories",
      },
      brands: {
        gobo_dk: "Gobo DK",
        gobo_se: "Gobo SE",
        gobo_fi: "Gobo FI",
        gobo_light: "Gobo Light Solution",
        ljusdesign: "Ljusdesign",
      },
    },
    image_editor: {
      change: "Change",
      drop_hint: "Drop a file to upload, or click to select it.",
      editable_content: "Editable content",
      title: "Upload and resize image",
      update_image: "Update Image",
    },
    import: {
      action: {
        download_error_report: "Download the error report",
        import: "Import",
        import_another: "Import another file",
      },
      error: {
        unable: "Unable to import this file.",
      },
      idle: {
        description_1:
          "You can import sales, companies, contacts, companies, notes, and tasks.",
        description_2:
          "Data must be in a JSON file matching the following sample:",
      },
      status: {
        all_success: "All records were imported successfully.",
        complete: "Import complete.",
        failed: "Failed",
        imported: "Imported",
        in_progress:
          "Import in progress, please don't navigate away from this page.",
        some_failed: "Some records were not imported.",
        table_caption: "Import status",
      },
      title: "Import Data",
    },
    settings: {
      companies: {
        segments: "Segments",
      },
      dark_mode_logo: "Dark Mode Logo",
      deals: {
        categories: "Categories",
        currency: "Currency",
        pipeline_help:
          "Select which deal stages should count as pipeline deals.",
        pipeline_statuses: "Pipeline Statuses",
        stages: "Stages",
      },
      light_mode_logo: "Light Mode Logo",
      notes: {
        statuses: "Statuses",
      },
      reset_defaults: "Reset to Defaults",
      save_error: "Failed to save configuration",
      saved: "Configuration saved successfully",
      saving: "Saving...",
      tasks: {
        types: "Types",
      },
      preferences: "Preferences",
      title: "Settings",
      app_title: "App Title",
      sections: {
        branding: "Branding",
        bc_sync: "BC Sync",
        notifications: "Notifications",
      },
      validation: {
        duplicate: "Duplicate %{display_name}: %{items}",
        in_use:
          "Cannot remove %{display_name} that are still used by deals: %{items}",
        validating: "Validating\u2026",
        entities: {
          categories: "categories",
          stages: "stages",
        },
      },
    },
    voice_agent: {
      language: "Voice language",
    },
    bc_environment: {
      label: "Main BC environment",
    },
    theme: {
      dark: "Dark",
      label: "Theme",
      light: "Light",
      system: "System",
    },
    language: "Language",
    navigation: {
      label: "CRM navigation",
    },
    mobile_nav: {
      mega_menu_title: "Menu",
      open_menu: "Open menu",
      close_menu: "Close",
      my_tasks: "My tasks",
      section_main: "Main",
      section_account: "Account",
    },
    profile: {
      inbound: {
        description:
          "You can start sending emails to your server's inbound email address, e.g. by adding it to the %{field} field. Atomic CRM will process the emails and add notes to the corresponding contacts.",
        title: "Inbound email",
      },
      mcp: {
        title: "MCP Server",
        description:
          "Use this URL to connect your AI assistant to your CRM data via the Model Context Protocol (MCP).",
      },
      password: {
        change: "Change password",
      },
      password_reset_sent:
        "A reset password email has been sent to your email address",
      record_not_found: "Record not found",
      title: "Profile",
      updated: "Your profile has been updated",
      update_error: "An error occurred. Please try again",
    },
    validation: {
      invalid_url: "Must be a valid URL",
      invalid_linkedin_url: "URL must be from linkedin.com",
    },
    config: {
      deal_stages: {
        opportunity: "Opportunity",
        "proposal-sent": "Proposal Sent",
        "in-negociation": "In Negotiation",
        won: "Won",
        lost: "Lost",
        delayed: "Delayed",
      },
      deal_categories: {
        other: "Other",
        copywriting: "Copywriting",
        "print-project": "Print project",
        "ui-design": "UI Design",
        "website-design": "Website design",
      },
      note_statuses: {
        cold: "Cold",
        warm: "Warm",
        hot: "Hot",
        "in-contract": "In Contract",
      },
      task_types: {
        none: "None",
        email: "Email",
        demo: "Demo",
        lunch: "Lunch",
        meeting: "Meeting",
        "follow-up": "Follow-up",
        "thank-you": "Thank you",
        ship: "Ship",
        call: "Call",
      },
      company_sectors: {
        "communication-services": "Communication Services",
        "consumer-discretionary": "Consumer Discretionary",
        "consumer-staples": "Consumer Staples",
        energy: "Energy",
        financials: "Financials",
        "health-care": "Health Care",
        industrials: "Industrials",
        "information-technology": "Information Technology",
        materials: "Materials",
        "real-estate": "Real Estate",
        utilities: "Utilities",
      },
    },
  },
} as const;

type MessageSchema<T> = {
  [K in keyof T]: T[K] extends string
    ? string
    : T[K] extends Record<string, unknown>
      ? MessageSchema<T[K]>
      : never;
};

type DeepPartial<T> = {
  [K in keyof T]?: T[K] extends Record<string, unknown>
    ? DeepPartial<T[K]>
    : T[K];
};

export type CrmMessages = MessageSchema<typeof englishCrmMessages>;
export type PartialCrmMessages = DeepPartial<CrmMessages>;
